import React from 'react'

const BundleTicketBlock = ({ icon, count, countLabel, title }) => {
  return (
  <div className="single-bundle-card__ticket-block">
    <div className="single-bundle-card__ticket-icon">{icon}</div>
    <div className="single-bundle-card__ticket-info">
      <span className="single-bundle-card__ticket-value">{countLabel || `${count} Tickets`}</span>
      <span className="single-bundle-card__ticket-title">{title}</span>
    </div>
  </div>
  );
};

export default BundleTicketBlock;